<template>
  <div class="organism-system-resource_container">
    <div class="organism-system-resource_line"></div>

    <div class="organism-system-resource_header">
      <label class="header__label">System Resource</label>
      <div class="header__data-picker">
        <label class="data-picker__label">Date</label>
        <molecule-date-picker-period
          type="dateNtime"
          :maxDate="datePicker.end"
          :minDate="datePicker.start"
          :dateNow="datePicker.now"
          v-model="datePicker"
          class="data-picker__input"
        ></molecule-date-picker-period>
      </div>
    </div>

    <div v-if="cpu.dataset.length || memory.dataset.length || storageData" class="organism-system-resource_body">
      <div class="resource__cpu" v-if="cpu.dataset.length">
        <atom-line-chart
          :title="cpu.title"
          :dataset="cpu.dataset"
        ></atom-line-chart>
      </div>

      <div class="resource__memory" v-if="memory.dataset.length">
        <atom-line-chart
          :title="memory.title"
          :dataset="memory.dataset"
        ></atom-line-chart>
      </div>

      <div v-if="storageData" class="resource__storage">
        <molecule-progress-bar-list
          title="Storage Usage"
          :dataset="storageData.disks"
        ></molecule-progress-bar-list>
      </div>
    </div>

    <div v-else class="organism-system-resource_body text-center">
      <b-card>
        <span>No system resource from selected date and time.</span>
      </b-card>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon"
import AtomLineChart from "@/components/atoms/graphs/AtomLineChart.vue"
import MoleculeDatePickerPeriod from "@/components/molecules/MoleculeDatePickerPeriod.vue"
import MoleculeProgressBarList from "@/components/molecules/serverManagementModule/server/MoleculeProgressBarList.vue"
import MoleculeDoughnutChartList from "@/components/molecules/serverManagementModule/server/MoleculeDoughnutChartList.vue"
import { BCard } from "bootstrap-vue"
export default {
  name: "OrganismSystemResource",
  components: {
    AtomLineChart,
    MoleculeDatePickerPeriod,
    MoleculeProgressBarList,
    MoleculeDoughnutChartList,
    BCard
  },
  props: {
    cpuData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    memoryData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    storageData: {
      type: [Object, null],
      required: false,
      default: null,
    },
  },
  watch: {
    cpuData: {
      deep: true,
      handler() {
        this.cpuInjectData()
      },
    },
    memoryData: {
      deep: true,
      handler() {
        this.memoryInjectData()
      },
    },
    datePicker: {
      deep: true,
      handler() {
        this.$emit("datetimeParams", this.datePicker)
      },
    },
  },
  data() {
    return {
      componentKey: 0,
      datePicker: {
        start: DateTime.now().plus({ days: -1 }).toString(),
        end: DateTime.now().toString(),
        now: DateTime.now().toString()
      },
      cpu: {
        title: "CPU",
        dataset: [],
      },
      memory: {
        title: "Memory",
        dataset: [],
      },
      network: [
        {
          title: "Goal",
          subTitle: "$100000",
          color: "primary",
          value: 100000,
          max: 500000,
        },
        {
          title: "Retention",
          subTitle: "90%",
          color: "danger",
          value: 90,
          max: 100,
        },
        {
          title: "Users",
          subTitle: "100K",
          color: "warning",
          value: 100,
          max: 400,
        },
        {
          title: "Goal",
          subTitle: "$100000",
          color: "primary",
          value: 100000,
          max: 500000,
        },
        {
          title: "Retention",
          subTitle: "90%",
          color: "danger",
          value: 90,
          max: 100,
        },
        {
          title: "Users",
          subTitle: "100K",
          color: "warning",
          value: 100,
          max: 400,
        },
      ],
      storage: [
        {
          title: "Goal",
          subTitle: "$100000",
          color: "primary",
          value: 100000,
          max: 500000,
        },
        {
          title: "Retention",
          subTitle: "90%",
          color: "danger",
          value: 90,
          max: 100,
        },
        {
          title: "Users",
          subTitle: "100K",
          color: "warning",
          value: 100,
          max: 400,
        },
        {
          title: "Goal",
          subTitle: "$100000",
          color: "primary",
          value: 100000,
          max: 500000,
        },
        {
          title: "Retention",
          subTitle: "90%",
          color: "danger",
          value: 90,
          max: 100,
        },
        {
          title: "Users",
          subTitle: "100K",
          color: "warning",
          value: 100,
          max: 400,
        },
        {
          title: "Goal",
          subTitle: "$100000",
          color: "primary",
          value: 100000,
          max: 500000,
        },
      ],
      processCPU: [
        {
          title: "Google Chrome",
          subTitle: "59.3%",
          color: "primary",
          value: 59.3,
          max: 100,
        },
        {
          title: "Mozila Firefox",
          subTitle: "	6.1%",
          color: "danger",
          value: 61,
          max: 100,
        },
        {
          title: "Apple Safari",
          subTitle: "14.6%",
          color: "success",
          value: 46,
          max: 100,
        },
        {
          title: "Internet Explorer",
          subTitle: "4.2%",
          color: "secondary",
          value: 42,
          max: 100,
        },
        {
          title: "Opera Mini",
          subTitle: "8.4%",
          color: "warning",
          value: 84,
          max: 100,
        },
      ],
      processMemory: [
        {
          title: "Google Chrome",
          subTitle: "59.3%",
          color: "primary",
          value: 59.3,
          max: 100,
        },
        {
          title: "Mozila Firefox",
          subTitle: "	6.1%",
          color: "danger",
          value: 61,
          max: 100,
        },
        {
          title: "Apple Safari",
          subTitle: "14.6%",
          color: "success",
          value: 46,
          max: 100,
        },
        {
          title: "Internet Explorer",
          subTitle: "4.2%",
          color: "secondary",
          value: 42,
          max: 100,
        },
        {
          title: "Opera Mini",
          subTitle: "8.4%",
          color: "warning",
          value: 84,
          max: 100,
        },
        {
          title: "Microsoft Edge",
          subTitle: "4.8%",
          color: "primary",
          value: 48,
          max: 100,
        },
      ],
    }
  },
  mounted() {
    this.cpuInjectData()
    this.memoryInjectData()
  },
  methods: {
    cpuInjectData() {
      this.cpu.dataset = []
      let cpuDataSetTimestamp = this.cpuData?.processorIndices?._Total?.timestamp
      let cpuDataSetValue = this.cpuData?.processorIndices?._Total?.percentProcessor
      // Pair the value from backend to use in echart
      cpuDataSetTimestamp?.forEach((timestamp, i) => {
        cpuDataSetValue.forEach((value, j) => {
          if (i === j) {
            this.cpu.dataset.push({
              timestamp: timestamp,
              value: value,
            })
          }
        })
      })
    },
    memoryInjectData() {
      this.memory.dataset = []
      let memoryDataSetTimestamp =
        this.memoryData?.timestamp
      let memoryDataSetValue =
        this.memoryData?.memoryPercentUsed
      // Pair the value from backend to use in echart
      memoryDataSetTimestamp?.forEach((timestamp, i) => {
        memoryDataSetValue.forEach((value, j) => {
          if (i === j) {
            this.memory.dataset.push({
              timestamp: timestamp,
              value: value,
            })
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0;
}

.organism-system-resource_container {
  width: 100%;
  background-color: #ffffff;
}

// line
.organism-system-resource_line {
  border: 0.5px solid #ebe9f1;
}

// header
.organism-system-resource_header {
  padding: 15px 15px 15px 15px;
}
.header__label {
  font-size: 14px;
  font-weight: 700;
  color: #6e6b7b;
}
.header__data-picker {
  margin-top: 8px;
}
.data-picker__label {
  font-size: 12px;
  color: #5e5873;
  margin-right: 10px;
}

// body
.organism-system-resource_body {
  padding: 15px 15px 15px 15px;
}

// memory
.resource__memory {
  margin-top: 20px;
}


// double card
.resource__container-double {
  margin-top: 20px;
}

// network
.resource__network,
.resource__storage,
.resource__process-cpu,
.resource__process-memory {
  width: 100%;
}
.resource__storage,
.resource__process-memory {
  margin-top: 20px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .organism-system-resource_header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 29px 38px 21px 38px;
  }
  .header__data-picker {
    margin-top: 0;
    display: flex;
    align-items: center;
  }

  .organism-system-resource_body {
    padding: 15px 38px 30px 38px;
  }

  // network
  .resource__network
  {
    width: 50%;
  }
  .resource__network {
    padding-right: 12px;
  }

}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
